var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00033 7.33317C4.9208 7.33317 5.75413 6.96007 6.35735 6.35686C6.96056 5.75364 7.33366 4.92031 7.33366 3.99984C7.33366 3.07936 6.96056 2.24603 6.35735 1.64281C5.75413 1.0396 4.9208 0.666504 4.00033 0.666504C3.07985 0.666504 2.24652 1.0396 1.6433 1.64281C1.04009 2.24603 0.666992 3.07936 0.666992 3.99984C0.666992 4.92031 1.04009 5.75364 1.6433 6.35686C2.24652 6.96007 3.07985 7.33317 4.00033 7.33317Z",
    stroke: "#827A7A",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4.77067V4.104C4.55228 4.104 5 3.65629 5 3.104C5 2.55172 4.55228 2.104 4 2.104C3.44772 2.104 3 2.55172 3 3.104",
    stroke: "#827A7A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99967 6.27083C4.22979 6.27083 4.41634 6.08429 4.41634 5.85417C4.41634 5.62405 4.22979 5.4375 3.99967 5.4375C3.76956 5.4375 3.58301 5.62405 3.58301 5.85417C3.58301 6.08429 3.76956 6.27083 3.99967 6.27083Z",
    fill: "#827A7A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "static/media/icon_help.c65b734c0021ce4addade97fe7f91f15.svg";
export { ForwardRef as ReactComponent };